export default __webpack_public_path__ + "static/PWAs-VS-APPN-e021646e80742e04a63f0c0f3263bb90.jpg";